// eslint-disable-next-line import/no-anonymous-default-export
export default {
  apiKey: 'AIzaSyD0QjOozn_Mw87Aac1nSW31yK4vdXLDYsE',
  discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
};
